import { useState } from "react";
import { toast } from "sonner";
import { PageTitle, Card, Btn, Badge } from "./ui";

const Field = ({ label, testId, ...props }) => (
  <label className="block">
    <span className="text-sm font-semibold mb-1 block">{label}</span>
    <input {...props} data-testid={testId} className="w-full h-10 px-3 border border-[#E2E2E2] text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#111111]" />
  </label>
);

const TABS = ["Vispārīgie", "Piegāde", "Maksājumi", "Nodokļi", "Lokalizācija"];

export default function Settings() {
  const [tab, setTab] = useState("Vispārīgie");
  const save = (e) => { e.preventDefault(); toast.success("Iestatījumi saglabāti (DEMO)"); };

  return (
    <div data-testid="admin-settings">
      <PageTitle>Iestatījumi</PageTitle>
      <div className="flex gap-2 flex-wrap mb-5">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} data-testid={`settings-tab-${t}`}
            className={`text-xs font-bold uppercase tracking-wider px-3 py-1.5 border transition-colors ${tab === t ? "bg-[#111111] text-white border-[#111111]" : "border-[#E2E2E2] hover:border-[#111111] bg-white"}`}>{t}</button>
        ))}
      </div>
      <form onSubmit={save} className="max-w-3xl space-y-4">
        {tab === "Vispārīgie" && (
          <Card className="p-6 space-y-4" data-testid="settings-general">
            <h2 className="text-sm font-bold uppercase tracking-widest">Veikala informācija</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              <Field label="Veikala nosaukums" defaultValue="E-Commerce DEMO" testId="settings-name" />
              <Field label="E-pasts" defaultValue="info@ecommercedemo.lv" testId="settings-email" />
              <Field label="Tālrunis" defaultValue="+371 20 000 000" testId="settings-phone" />
              <Field label="Adrese" defaultValue="Demo iela 1, Demo pilsēta, LV-0000" testId="settings-address" />
            </div>
            <div className="flex flex-wrap gap-5 text-sm font-semibold pt-2">
              <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="settings-maintenance" /> Veikals atvērts (izslēgt = apkopes režīms)</label>
              <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="settings-guest" /> Atļaut viesa pirkumus</label>
              <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="settings-reviews" /> Atļaut atsauksmes</label>
            </div>
          </Card>
        )}
        {tab === "Piegāde" && (
          <Card className="p-6 space-y-3" data-testid="settings-shipping">
            <h2 className="text-sm font-bold uppercase tracking-widest mb-1">Piegādes metodes</h2>
            {[
              ["DPD kurjers", "4,99 € · 1–3 darba dienas", true],
              ["Omniva pakomāts", "2,99 € · 1–3 darba dienas", true],
              ["Venipak kurjers", "5,49 € · 1–2 darba dienas", false],
              ["Saņemšana demo veikalā", "Bezmaksas · tajā pašā dienā", true],
            ].map(([n, d, on]) => (
              <div key={n} className="flex items-center justify-between border border-[#E2E2E2] p-4">
                <div><div className="text-sm font-bold">{n}</div><div className="text-xs text-[#6B6B6B]">{d}</div></div>
                <label className="flex items-center gap-2 text-xs font-bold"><input type="checkbox" defaultChecked={on} className="accent-[#D0121A]" /> Aktīva</label>
              </div>
            ))}
            <Field label="Bezmaksas piegāde no (€)" type="number" defaultValue="60" testId="settings-free-shipping" />
          </Card>
        )}
        {tab === "Maksājumi" && (
          <Card className="p-6 space-y-3" data-testid="settings-payments">
            <h2 className="text-sm font-bold uppercase tracking-widest mb-1">Maksājumu metodes</h2>
            {[
              ["Internetbanka (banklink)", "Swedbank, SEB, Citadele, Luminor", true],
              ["Maksājumu kartes (Stripe)", "Visa, Mastercard, Apple Pay", true],
              ["Rēķins uzņēmumiem", "Pēcapmaksa 7–30 dienas ar līgumu", true],
              ["PayPal", "Nav konfigurēts — nepieciešams modulis", false],
              ["Skaidra nauda saņemot", "Tikai demo veikalā", false],
            ].map(([n, d, on]) => (
              <div key={n} className="flex items-center justify-between border border-[#E2E2E2] p-4">
                <div><div className="text-sm font-bold">{n}</div><div className="text-xs text-[#6B6B6B]">{d}</div></div>
                <label className="flex items-center gap-2 text-xs font-bold"><input type="checkbox" defaultChecked={on} className="accent-[#D0121A]" /> Aktīva</label>
              </div>
            ))}
          </Card>
        )}
        {tab === "Nodokļi" && (
          <Card className="p-6 space-y-3" data-testid="settings-taxes">
            <h2 className="text-sm font-bold uppercase tracking-widest mb-1">Nodokļu likmes</h2>
            {[
              ["PVN standarta likme (LV)", "21%", "green"],
              ["PVN samazinātā likme", "12%", "gray"],
              ["PVN 0% (ES B2B ar derīgu PVN nr.)", "0% — reverse charge", "black"],
            ].map(([n, v, c]) => (
              <div key={n} className="flex items-center justify-between border border-[#E2E2E2] p-4">
                <span className="text-sm font-bold">{n}</span>
                <Badge color={c}>{v}</Badge>
              </div>
            ))}
            <div className="flex flex-wrap gap-5 text-sm font-semibold pt-2">
              <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="settings-prices-incl-vat" /> Rādīt cenas ar PVN (B2C)</label>
              <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[#D0121A]" data-testid="settings-vat-validate" /> Automātiska ES PVN nr. validācija (VIES)</label>
            </div>
          </Card>
        )}
        {tab === "Lokalizācija" && (
          <Card className="p-6 space-y-4" data-testid="settings-localization">
            <h2 className="text-sm font-bold uppercase tracking-widest">Valodas un valūtas</h2>
            <div className="space-y-3">
              {[["Latviešu (LV)", "Noklusējuma", true], ["Angļu (EN)", "Nepieciešams tulkojumu modulis", false], ["Krievu (RU)", "Nepieciešams tulkojumu modulis", false]].map(([n, d, on]) => (
                <div key={n} className="flex items-center justify-between border border-[#E2E2E2] p-4">
                  <div><div className="text-sm font-bold">{n}</div><div className="text-xs text-[#6B6B6B]">{d}</div></div>
                  <label className="flex items-center gap-2 text-xs font-bold"><input type="checkbox" defaultChecked={on} className="accent-[#D0121A]" /> Aktīva</label>
                </div>
              ))}
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <Field label="Pamata valūta" defaultValue="EUR (€)" testId="settings-currency" />
              <Field label="Laika zona" defaultValue="Europe/Riga (UTC+2/+3)" testId="settings-timezone" />
            </div>
          </Card>
        )}
        <Btn type="submit" variant="red" className="px-8 py-3 text-sm" data-testid="settings-save-btn">Saglabāt iestatījumus</Btn>
      </form>
    </div>
  );
}
